export const fetchTutorsTypes = [
  'FETCH_TUTORS',
  'FETCH_TUTORS_SUCCESS',
  'FETCH_TUTORS_FAIL',
];

export const fetchTutorTypes = [
  'FETCH_TUTOR',
  'FETCH_TUTOR_SUCCESS',
  'FETCH_TUTOR_FAIL',
];

export const setReviewVisibilityTypes = [
  'SET_REVIEW_VISIBILITY',
  'SET_REVIEW_VISIBILITY_SUCCESS',
  'SET_REVIEW_VISIBILITY_FAIL',
];

export const addNoteTypes = [
  'ADD_NOTE',
  'ADD_NOTE_SUCCESS',
  'ADD_NOTE_FAIL',
];

export const editNoteTypes = [
  'EDIT_NOTE',
  'EDIT_NOTE_SUCCESS',
  'EDIT_NOTE_FAIL',
];

export const removeNoteTypes = [
  'REMOVE_NOTE',
  'REMOVE_NOTE_SUCCESS',
  'REMOVE_NOTE_FAIL',
];

export const removeTutorTypes = [
  'REMOVE_TUTOR',
  'REMOVE_TUTOR_SUCCESS',
  'REMOVE_TUTOR_FAIL',
];

export const CLEAR_SELECTED_TUTOR = 'CLEAR_SELECTED_TUTOR';



// WEBPACK FOOTER //
// ./src/modules/tutors/action_types.js